import type { ReactNode } from "react"

// The two-up spotlight card frame shared by Spotlight and CollectionSpotlight: a
// bordered surface card that becomes a 50/50 media + content grid at @3xl.
export const SpotlightShell = ({ children }: { children: ReactNode }) => (
  <div className="@container">
    <div className="rounded-12x border-line-subtle bg-surface duration-moderate ease-productive hover:shadow-raised overflow-hidden border transition-shadow @3xl:mx-auto @3xl:grid @3xl:max-w-256 @3xl:grid-cols-2 @3xl:items-stretch">
      {children}
    </div>
  </div>
)
